import { HomeMetric } from '../../../models/home';
import { HomeMetricsResponse, HomeMetricResponse } from '../../../models/home/dtos';

export class MetricsAdapter {
  static toViewModel(dto: HomeMetricsResponse): HomeMetric[] {
    const seen = new Set<string>();
    const mapped = (dto.metrics ?? []).map(MetricsAdapter.mapMetric);
    return mapped.filter((metric) => {
      const key = (metric.label ?? '').trim().toLowerCase();
      if (!key) return false;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  private static mapMetric(metric: HomeMetricResponse): HomeMetric {
    const delta = metric.delta ?? undefined;
    return {
      label: metric.label ?? 'Métrica',
      value: `${metric.value ?? 0}`,
      helperText: delta ?? '',
      trend: MetricsAdapter.mapTrend(delta),
      trendLabel: delta,
    };
  }

  private static mapTrend(delta?: string): HomeMetric['trend'] {
    if (!delta) return undefined;
    if (delta.trim().startsWith('-')) return 'down';
    if (delta.trim().startsWith('+')) return 'up';
    return 'steady';
  }
}
